"use client";

import { useEffect, useState } from "react";
import { Moon, Monitor, Sun } from "lucide-react";

import { THEME_MODES, type ThemeMode } from "./theme";
import { useThemeMode } from "./ThemeProvider";

const ICONS: Record<ThemeMode, typeof Sun> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
};

/** Port of the reference's ThemeToggle, against the local theme.ts instead
 * of next-themes' useTheme. Same mounted-guard shape (avoids a hydration
 * mismatch: the icon depends on client-only localStorage state). */
export function ThemeToggle() {
  const { mode, setMode } = useThemeMode();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="w-8 h-8" aria-hidden="true" />;
  }

  const cycle = () => {
    const idx = THEME_MODES.indexOf(mode);
    setMode(THEME_MODES[(idx + 1) % THEME_MODES.length]);
  };

  const Icon = ICONS[mode];

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Theme: ${mode}`}
      title={`Theme: ${mode} — click to change`}
      className="w-8 h-8 rounded-lg border border-edge bg-surface flex items-center justify-center text-ink-light hover:text-ink hover:border-accent transition-colors"
    >
      <Icon size={14} />
    </button>
  );
}
